import {
    ACTION_STATES,
    BasicAjaxAction,
    ComplexAction,
    createHandler,
    createReducer,
    DefaultAction,
} from "core/actions";
import log from "loglevel";
import TagsService from "services/tagsService";
import envconfig from "../../../../envconfig";

export const initState = {
    reviewTags: [],
    loadReviewTags: ACTION_STATES.NO_REQUEST,
    tagForm: {
        value: "",
        color: "#777",
        deleted: false,
        order: 0,
    },
    creatingTag: ACTION_STATES.NO_REQUEST,
    reviewTemplates: [],
    loadReviewTemplates: ACTION_STATES.NO_REQUEST,
    templateForm: {
        id: null,
        name: "",
        instructionValue: "",
    },
    savingTemplate: ACTION_STATES.NO_REQUEST,
    deletingTemplate: ACTION_STATES.NO_REQUEST,
};

export class CREATE_TAG extends ComplexAction {
    constructor() {
        const props = {
            error: false,
        };
        super(null, props);
    }







    successRdx(state, { payload }) {
        log.debug("payload", payload);
        return {
            ...state,
            reviewTags: [payload.data, ...state.reviewTags],
            tagForm: { ...initState.tagForm },
        };
    }
}

export class CHANGE_TAG_FORM extends DefaultAction {
    constructor() {
        const props = {
            error: false,
        };
        super(null, props);
    }

    callRdx(state, { payload }) {
        log.debug("callRdx", state, payload);
        let form = {};
        if (payload && payload.attribute) {
            form = {
                ...state.tagForm,
                [payload.attribute]: payload.value,
            };
        }
        return {
            ...state,
            tagForm: form,
        };
    }
}

export class SAVE_TEMPLATE extends ComplexAction {
    constructor() {
        const props = {
            error: false,
        };
        super(null, props);
    }

    successRdx(state, { payload }) {
        log.debug("payload", payload);
        let newReviewTemplates = [payload.data, ...state.reviewTemplates];
        if (payload.data.editing) {
            newReviewTemplates = state.reviewTemplates.map((template) =>
                template.id === payload.data.id
                    ? { id: payload.data.id, name: payload.data.name, instructionValue: payload.data.instructionValue }
                    : template
            );
        }
        return {
            ...state,
            reviewTemplates: [...newReviewTemplates],
            tagForm: { ...initState.templateForm },
            savingTemplate: ACTION_STATES.SUCCESS,
        };
    }
}

export class CHANGE_TEMPLATE_FORM extends DefaultAction {
    constructor() {
        const props = {
            error: false,
        };
        super(null, props);
    }

    callRdx(state, { payload }) {
        log.debug("callRdx", state, payload);
        let form = {};
        if (payload && payload.attribute) {
            form = {
                ...state.templateForm,
                [payload.attribute]: payload.value,
            };
        }
        return {
            ...state,
            templateForm: form,
        };
    }
}

export class DELETE_TEMPLATE extends ComplexAction {
    constructor() {
        const props = {
            error: false,
        };
        super(null, props);
    }

    successRdx(state, { payload }) {
        log.debug("payload", payload);
        return {
            ...state,
            reviewTemplates: state.reviewTemplates.filter((template) => template.id !== payload.data),
            deletingTemplate: ACTION_STATES.SUCCESS,
        };
    }
}

export class CLEAR extends DefaultAction {
    constructor() {
        const props = {
            error: false,
        };
        super(null, props);
    }

    callRdx() {
        return initState;
    }
}

export const actions = {
    CHANGE_TAG_FORM: new CHANGE_TAG_FORM(),
    CREATE_TAG: new CREATE_TAG("creatingTag"),
    GET_REVIEW_TAGS: new BasicAjaxAction("GET_REVIEW_TAGS", "reviewTags", TagsService.filter, {
        loadingAtr: "loadReviewTags",
        debounce: envconfig.SEARCH_INPUT_DEBOUNCE_TIME,
    }),
    CLEAR: new CLEAR(),
};

const handlers = createHandler(actions);

export default createReducer(initState, handlers);
